export { isDeckPresetKey, useGetDeckPageQueries } from "#use-deck-page-query-options";
export type {
  DeckPageInput,
  DeckPageQueryOptions,
  DeckPresetKey,
} from "#use-deck-page-query-options";
